module.exports = __webpack_public_path__ + "assets/img/29_274_big.46c093a1.jpg";